import React from "react"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import LogoWhite from "../images/svg/logo-white.svg"

const Footer = props => {
  return (
    <footer>
      <div className="bg-black pt-4 top-footer">
        <Container>
          <Row className="align-items-center justify-content-end">
            <Col md={3} className="mb-3">
              <LogoWhite width="180" />
            </Col>
            <Col md={4} className="pl-md-5 mb-3">
              <a
                href="https://goo.gl/maps/b8CC4faXsDVXQTRTA"
                target="_blank"
                rel="noopener noreferrer"
                className="h5 mb-0"
              >
                i.Farm Inc. 15419 1st Ave South Burien, WA 98148
              </a>
            </Col>
            <Col md={4} className="pl-md-5 mb-3">
              <a href="mailto:support@firstday.app" className="h5 d-block">
                support@firstday.app
              </a>
              <a href="tel:+12064020900" className="h5 mb-0">
                +1 (206) 402-0900
              </a>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-dark py-3">
        <Container className="text-white text-center font-weight-light h5 mb-0">
          @2020 i.Farm, Inc. ALL RIGHTS RESERVED.
        </Container>
      </div>
    </footer>
  )
}

export default Footer
